function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-color: ",
        ";\n  border-style: solid;\n  color: ",
        ";\n  text-transform: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 300px;\n  && .ant-tag {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 300px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "+ ",
        " more"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import { lighten } from "polished";
import { t } from "ttag";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Popover, Typography, Tag as AntTag, Space } from "antd";
var POPUP_LIMIT = 7;
var ITEMS_MAX = 3;
var Text = Typography.Text, Paragraph = Typography.Paragraph;
var Tag = styled(AntTag)(_templateObject(), function(props) {
    return props.hue && lighten(0.05, props.hue);
}, function(props) {
    return props.hue;
}, function(props) {
    return props.$uppercase ? "uppercase" : "none";
});
var PopupContent = styled.div(_templateObject1());
var getTags = function(param) {
    var items = param.items, uppercase = param.uppercase;
    return items.map(function(param) {
        var id = param.id, color = param.color, name = param.name;
        return /*#__PURE__*/ React.createElement(Tag, {
            style: {
                marginRight: 0
            },
            key: id,
            hue: color,
            $uppercase: uppercase
        }, name);
    });
};
var itemsPopup = function(items, isTag, uppercase) {
    var moreCount = items.length - POPUP_LIMIT;
    var displayItems = items.slice(0, POPUP_LIMIT);
    return /*#__PURE__*/ React.createElement(PopupContent, null, /*#__PURE__*/ React.createElement(Space, {
        size: 8,
        wrap: true
    }, isTag && getTags({
        items: displayItems,
        uppercase: uppercase
    }), !isTag && displayItems.map(function(param) {
        var id = param.id, name = param.name;
        return /*#__PURE__*/ React.createElement(Paragraph, {
            key: id
        }, name);
    }), moreCount > 0 && /*#__PURE__*/ React.createElement(Paragraph, {
        type: "secondary"
    }, t(_templateObject2(), moreCount))));
};
var ShowMore = function(param) {
    var items = param.items, _param_isTag = param.isTag, isTag = _param_isTag === void 0 ? false : _param_isTag, _param_uppercase = param.uppercase, uppercase = _param_uppercase === void 0 ? true : _param_uppercase;
    var displayItems = items.slice(0, ITEMS_MAX);
    return /*#__PURE__*/ React.createElement(Space, {
        size: 8,
        wrap: true
    }, isTag && getTags({
        items: displayItems,
        uppercase: uppercase
    }), !isTag && /*#__PURE__*/ React.createElement(Text, {
        style: {
            marginRight: 8
        }
    }, displayItems.map(function(param) {
        var name = param.name;
        return name;
    }).join(", ")), items.length > ITEMS_MAX && /*#__PURE__*/ React.createElement(Popover, {
        content: itemsPopup(items, isTag, uppercase)
    }, /*#__PURE__*/ React.createElement(Text, null, "+", items.length - ITEMS_MAX, /*#__PURE__*/ React.createElement(InfoCircleOutlined, {
        style: {
            marginLeft: 8
        }
    }))));
};
export default ShowMore;
